export type PageNumber = number | 'ellipsis';

/**
 * The page buttons to draw: the first, the last, the ones around the current
 * one, and a gap where the rest were.
 *
 * A row of buttons that grows with the table is a row nobody can aim at, so the
 * count is fixed: at most `2 * delta + 5` entries whatever the total.
 */
export function pageNumbers(current: number, total: number, delta = 2): PageNumber[] {
  if (total <= 2 * delta + 3) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const pages: PageNumber[] = [1];
  const start = Math.max(2, current - delta);
  const end = Math.min(total - 1, current + delta);

  if (start > 2) {
    pages.push('ellipsis');
  }
  for (let page = start; page <= end; page += 1) {
    pages.push(page);
  }
  if (end < total - 1) {
    pages.push('ellipsis');
  }
  pages.push(total);

  return pages;
}
